export default __webpack_public_path__ + "3aa749d38089cd7e5e32b4bfe6c6ea72.mp3";